"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPreferenceDurabilite = exports.ESubPartInvestissementsDurables = void 0;
const ESubPartInvestissementsDurables_1 = require("./ESubPartInvestissementsDurables");
Object.defineProperty(exports, "ESubPartInvestissementsDurables", { enumerable: true, get: function () { return ESubPartInvestissementsDurables_1.ESubPartInvestissementsDurables; } });
const ESubPreferenceDurabilite_1 = require("./ESubPreferenceDurabilite");
Object.defineProperty(exports, "ESubPreferenceDurabilite", { enumerable: true, get: function () { return ESubPreferenceDurabilite_1.ESubPreferenceDurabilite; } });
